import {Component, Input, OnInit} from '@angular/core';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {IMAGE_RESOLUTION} from '@api/models/image/image-resolution';

export enum SectionHeaderTitleSize {
  Medium = 'medium',
  Large = 'large',
}
@Component({
  selector: 'lib-section-header',
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss']
})
export class SectionHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() subTitle: string;
  @Input() titleIcon: string  = '';
  @Input() titleIconUrl: string  = '';
  @Input() colorScheme: ColorScheme = ColorScheme.Dark;
  @Input() titleSize: SectionHeaderTitleSize = SectionHeaderTitleSize.Large;
  @Input() buttonTitle: string = '';
  @Input() routerLink: string = '';
  @Input() pageTitle = false;
  public imageResolution: IMAGE_RESOLUTION.LOW;

  constructor() { }

  ngOnInit(): void {
  }
}
